import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { cloneDeep } from 'lodash-es';
import './index.less';
import { CommonBg } from '../common-bg';
import { useMsgFail } from '../../utils/antd-message';
import { getDefaultAvartar, onAvartarError, runAtNextFrame, wrapAvartarUrl } from '../../utils';
import { uploadAvatar } from '../../service/common';
import { updateCurrentAccount, updateCurrentStudentAccount } from '../../service/login';
import { ACCOUNT_MODE } from '../../constants/login';
import { useStatistics } from '../../utils/statistics';
import config from '../../config';
var defaultDetail = {
  accountId: undefined,
  avatar: '',
  email: '',
  nickname: '',
  phone: '',
  wxBound: false,
  wxNickName: '',
  hasPassword: false
};
var fiveM = 5 * 1024 * 1024;
export function AccountInfo(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    currentAccount = _ref.currentAccount,
    tenantName = _ref.tenantName,
    onChange = _ref.onChange,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    active = _ref.active,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? ACCOUNT_MODE.ACCOUNT : _ref$mode,
    inInstitution = _ref.inInstitution,
    institutionName = _ref.institutionName;
  useStatistics('AccountInfo');
  var MsgFail = useMsgFail();
  var _useReducer = useReducer(function (pre, cur) {
      var result = _objectSpread(_objectSpread({}, pre), cur);
      runAtNextFrame(function () {
        onChange && onChange(result);
      });
      return result;
    }, cloneDeep(currentAccount || defaultDetail)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    detail = _useReducer2[0],
    setDetail = _useReducer2[1];
  var uploadInput = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showReUpload = _useState4[0],
    setShowReUpload = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    botVisible = _useState6[0],
    setBotVisible = _useState6[1];
  var handleClickUpload = useCallback(function () {
    var _uploadInput$current;
    (_uploadInput$current = uploadInput.current) === null || _uploadInput$current === void 0 ? void 0 : _uploadInput$current.click();
  }, []);
  var uploadImage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
      var formData, _yield$uploadAvatar, _yield$uploadAvatar$d, result, code, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formData = new FormData();
            formData.append('image', file);
            _context.prev = 2;
            _context.next = 5;
            return uploadAvatar(formData, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.accountId, config._productId);
          case 5:
            _yield$uploadAvatar = _context.sent;
            _yield$uploadAvatar$d = _yield$uploadAvatar.data;
            result = _yield$uploadAvatar$d.result;
            code = _yield$uploadAvatar$d.code;
            message = _yield$uploadAvatar$d.message;
            console.log(result);
            if (code === '0') {
              setDetail({
                avatar: result
              });
              setBotVisible(true);
            } else {
              MsgFail(message);
            }
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            console.error('upload fail', _context.t0);
            MsgFail('上传失败，请稍候再试');
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14]]);
    }));
    return function uploadImage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onInputChange = useCallback(function (e) {
    console.log(e.target.files[0]);
    var file = e.target.files[0];
    if (file.size > fiveM) {
      MsgFail('头像图片大小不得超过5M');
    } else {
      uploadImage(file);
    }
    e.target.value = '';
  }, []);
  var onSaveDetail = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var res, _res, _res$data, code, message;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          if (!(!detail.nickname || isSaving)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          setIsSaving(true);
          if (!(mode === ACCOUNT_MODE.STUDENT)) {
            _context2.next = 10;
            break;
          }
          _context2.next = 7;
          return updateCurrentStudentAccount(detail, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.accountId, config._productId);
        case 7:
          res = _context2.sent;
          _context2.next = 13;
          break;
        case 10:
          _context2.next = 12;
          return updateCurrentAccount(detail, config._productId);
        case 12:
          res = _context2.sent;
        case 13:
          _res = res, _res$data = _res.data, code = _res$data.code, message = _res$data.message;
          setIsSaving(false);
          if (code === '0') {
            onSuccess && onSuccess(detail);
          } else {
            MsgFail(message || '保存失败，请稍候再试');
            onError && onError(message || '保存失败，请稍候再试');
          }
          _context2.next = 24;
          break;
        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2["catch"](0);
          console.warn(_context2.t0);
          setIsSaving(false);
          MsgFail('保存失败，请稍候再试');
          onError && onError(_context2.t0);
        case 24:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 18]]);
  })), [currentAccount, detail, isSaving, mode, onError, onSuccess]);
  var content = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "login-account-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-avartar-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-avartar-inner",
      onMouseOver: function onMouseOver() {
        return setShowReUpload(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setShowReUpload(false);
      },
      onClick: handleClickUpload
    }, /*#__PURE__*/React.createElement("input", {
      onChange: onInputChange,
      accept: "image/png, image/jpeg",
      ref: uploadInput,
      className: "login-account-info-avartar-input",
      type: "file"
    }), /*#__PURE__*/React.createElement("img", {
      src: (detail === null || detail === void 0 ? void 0 : detail.avatar) ? wrapAvartarUrl(detail.avatar) : getDefaultAvartar(),
      onError: onAvartarError,
      className: "login-account-info-avartar",
      alt: ""
    }), showReUpload && /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-avartar-mask fontBold"
    }, "\u4FEE\u6539"), /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-avartar-border"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item"
    }, !inInstitution ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-label"
    }, "\u59D3\u540D"), /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-value"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "login-account-info-form-item-value-input",
      placeholder: "\u8BF7\u8F93\u5165\u59D3\u540D",
      value: detail.nickname,
      maxLength: 16,
      onChange: function onChange(e) {
        setDetail({
          nickname: e.target.value.trim()
        });
        setBotVisible(true);
      }
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-label"
    }, "\u59D3\u540D"), /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-value",
      title: institutionName
    }, institutionName))), tenantName && /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-label"
    }, "\u5B66\u6821"), /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-form-item-value",
      title: tenantName
    }, tenantName)));
  }, [detail.avatar, detail.nickname, handleClickUpload, inInstitution, institutionName, onInputChange, showReUpload, tenantName]);
  var footer = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "login-account-info-bot"
    }, botVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "login-account-info-bot-cancel btn-plain",
      onClick: onCancel
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "login-account-info-bot-success btn-primary ".concat(!detail.nickname || isSaving ? 'disabled' : ''),
      onClick: onSaveDetail
    }, "\u786E\u5B9A")));
  }, [botVisible, detail.nickname, isSaving, onCancel, onSaveDetail]);
  useEffect(function () {
    setDetail(cloneDeep(currentAccount || defaultDetail));
  }, [currentAccount, active]);
  return /*#__PURE__*/React.createElement(CommonBg, {
    className: className,
    style: style,
    onClick: onClick,
    title: "\u4E2A\u4EBA\u4FE1\u606F",
    content: content,
    footer: footer
  });
}